import React from 'react';
import { Button as NextUIButton } from "@nextui-org/button";
import { AppThemeColor, AppThemeColorVariant, ButtonVariant } from '../../../types/theme';
import { APP_THEME_COLORS, THEME_PALETTE } from '../../theme/palette';
import Typography from './Typography';
import theme from '../../theme';

interface IButton {
  title: string;
  onClick: () => void;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  variant?: ButtonVariant;
  colorVariant?: AppThemeColorVariant;
  textColorVariant?: AppThemeColorVariant;
  textStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  icon?: any;
}

export default function Button({
  onClick,
  icon,
  title,
  className,
  disabled = false,
  loading = false,
  variant = 'primary',
  colorVariant = 'primary',
  textColorVariant,
  textStyle,
  style
}: IButton) {

  const bgColor = React.useMemo((): AppThemeColor | 'transparent' => {
    return variant === 'secondary' ? 'transparent' : THEME_PALETTE[colorVariant];
  }, [colorVariant, variant]);

  const borderColor = React.useMemo(() => {
    return variant === 'primary' ? 'transparent' : THEME_PALETTE[colorVariant];
  }, [colorVariant, variant]);

  const nextUIVariant = React.useMemo(() => {
    return variant === 'primary' ? 'solid' : 'bordered';
  }, [variant]);

  const textColor = React.useMemo(() => {
    if (textColorVariant) return textColorVariant;
    return variant === 'primary' ? 'background' : colorVariant;
  }, [textColorVariant, variant, colorVariant]);

  return (
    <NextUIButton
      style={{
        backgroundColor: bgColor,
        borderColor,
        ...style
      }}
      startContent={icon}
      variant={nextUIVariant}
      isDisabled={disabled}
      isLoading={loading}
      className={className}
      onClick={onClick}>
        <Typography 
          variant='button' 
          colorVariant={textColor}
          style={textStyle}>
            {title}
        </Typography>
    </NextUIButton>
  )
}